// Constant: Settings > Brand color
const BRAND_COLOR = '#7b8c9d'

// Constant: Settings > Brand color on dark
const BRAND_COLOR_ON_DARK = 'white'

// Constant: Settings > Brand color on light
const BRAND_COLOR_ON_LIGHT = BRAND_COLOR

// Constant: Settings > Confirmation code minimum length
const CONFIRMATION_CODE_MINIMUM_LENGTH = 5

// Constant: Settings > Default direction
const DEFAULT_DIRECTION = 'ltr'

// Constant: Settings > Default language
const DEFAULT_LANGUAGE = 'en'

// Constant: Settings > Default theme
const DEFAULT_THEME = 'light'

// Constant: Settings > Required storage fields
const REQUIRED_STORAGE_FIELDS = Object.freeze(['guides', 'interactions', 'language', 'theme'])

// Constant: Settings > Storage prefix
const STORAGE_PREFIX = 'aixStorage'

// Constant: Settings > Storage version
const STORAGE_VERSION = 1 // WARNING: Storage version should always be increased 1 unit

// Constant: Settings > Token expiration in minutes
const TOKEN_EXPIRATION_IN_MINUTES = 24 * 60

// Constant: Settings > Confirmation code minimum length
const TWO_FACTOR_AUTHENTICATION_CODE_LENGTH = 6

// Export
export {
	BRAND_COLOR,
	BRAND_COLOR_ON_DARK,
	BRAND_COLOR_ON_LIGHT,
	CONFIRMATION_CODE_MINIMUM_LENGTH,
	DEFAULT_DIRECTION,
	DEFAULT_LANGUAGE,
	DEFAULT_THEME,
	REQUIRED_STORAGE_FIELDS,
	STORAGE_PREFIX,
	STORAGE_VERSION,
	TOKEN_EXPIRATION_IN_MINUTES,
	TWO_FACTOR_AUTHENTICATION_CODE_LENGTH
}
